export const statusColor = (status) => {
    const colors = {
        draft: {
            badge: 'amber',
            background: 'vx-bg-slate-50 vx-border-slate-100',
        },
        scheduled: {
            badge: 'orange',
            background: 'vx-bg-orange-50 vx-border-orange-100',
        },
        published: {
            badge: 'teal',
            background: 'vx-bg-teal-50 vx-border-teal-100',
        },
        completed: {
            badge: 'neutral',
            background: 'vx-bg-slate-50 vx-border-slate-100',
        },
        paused: {
            badge: 'danger',
            background: 'vx-bg-slate-50 vx-border-slate-100',
        },
    };

    return (
        colors[status] || {
            badge: 'primary',
            background: 'vx-bg-sky-50 vx-border-sky-100',
        }
    );
};
